import { Injectable } from '@angular/core';
import { isBoolean, isNumber } from 'ionic-angular/util/util';
import { isArray } from 'rxjs/util/isArray';
import * as moment from 'moment';

@Injectable()
export class SearchUtilsService {
  constructor() {

  }

  public getSearchStringFromParams(searchParams: any): string {
    let search = '';

    Object.entries(searchParams).forEach(
      ([paramKey, paramValue]: [any, any]) => {
        if (!paramValue || (!isBoolean(paramValue) && !isNumber(paramValue) && !paramValue.length)) return;
        if (isArray(paramValue)) {
          search = this.handleArraySearchParam(search, paramKey, paramValue);
        } else {
          search = this.handleStringSearchParam(search, paramKey, paramValue);
        }
      });

    return search;
  }

  private handleArraySearchParam(search: string, paramKey: string, paramValue: any[]): string {
    paramValue.forEach(
      value => search += (search.length ? ',' : '') + paramKey + ':' + value
    );
    return search;
  }

  private handleStringSearchParam(search: string, paramKey: string, paramValue: string): string {
    switch (paramKey) {
      case 'endDate':
        paramValue = moment(paramValue, "YYYY-MM-DD").format("DD-MM-YYYY");
        search += (search.length ? ',' : '') + 'date<=' + paramValue;
        break;

      case 'startDate':
        paramValue = moment(paramValue, "YYYY-MM-DD").format("DD-MM-YYYY");
        search += (search.length ? ',' : '') + 'date>=' + paramValue;
        break;

      case 'endPkNumber':
        search += (search.length ? ',' : '') + 'number<=' + paramValue;
        break;

      case 'startPkNumber':
        search += (search.length ? ',' : '') + 'number>=' + paramValue;
        break;

      case 'replacementYear':
        search += (search.length ? ',' : '') +
          'pk.earlyPredictedReplacementDate>=' + moment(paramValue + '-01-01', "YYYY-MM-DD").format("DD-MM-YYYY") + ',' +
          'pk.earlyPredictedReplacementDate<=' + moment(Number(paramValue) + 1 + '-01-01', "YYYY-MM-DD").format("DD-MM-YYYY");
        break;

      default:
        search += (search.length ? ',' : '') + paramKey + ':' + paramValue;
        break;
    }
    return search;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/util/search-utils.service.ts